import styled from 'styled-components';

export const EditRowWrapper = styled.div`
  min-width: 370px;
`;
export const EditRowButtonsDiv = styled.div`
  display: flex;
  justify-content: space-around;
  padding-top: 10px;
  padding-bottom: 30px;
`;

export const StatementText = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  padding: 2px;
  min-height: 36px;
`;

export const FieldText = styled.div`
  width: 120px;
`;
